import { createSlice } from '@reduxjs/toolkit';
import { initialFlightPathViewerState } from 'reducers/initialStates';

const flightPathViewer = createSlice({
	name: 'flightPathViewer',
	initialState: {
		//Set by configureStore
	},
	reducers: {
		setFlightPathData(state, action) {
			state.data = action.payload;
		},
		setFlightPathDataLoading(state, action) {
			state.dataLoading = action.payload;
		},
		resetFlightPathViewerSlice() {
			return initialFlightPathViewerState;
		}
	}
});

export const { setFlightPathData, setFlightPathDataLoading, resetFlightPathViewerSlice } =
	flightPathViewer.actions;

export default flightPathViewer.reducer;

export const flightPathDataSelector = state => state.flightPathViewer.data;
export const flightPathDataLoadingSelector = state => state.flightPathViewer.dataLoading;
